export default __webpack_public_path__ + "static/media/extension_giftcard_silver_w3.d0389dde.svg";